import type { ColumnDef } from "@tanstack/react-table";
import type { InputMaybe } from "types/graphqlTypes";

export enum TableBreakpoint {
  Small = "sm",
  Medium = "md",
  Large = "lg",
  ExtraLarge = "xl",
}

export interface ITableProps<T extends Record<string, any>> {
  data: T[];
  className?: string;
  pageSize?: number;
  isOddEven?: boolean;
  isSticky?: boolean;
  isPaginationEnabled?: boolean;
  isMobileTableDiasbled?: boolean;

  columns: (
    | ColumnDef<T, string>
    | ColumnDef<T, number>
    | ColumnDef<T, Date>
    | ColumnDef<T, InputMaybe<string>>
    | ColumnDef<T, InputMaybe<number>>
    | ColumnDef<T, InputMaybe<Date>>
    | ColumnDef<T, InputMaybe<unknown>>
  )[];
}
